// Redirect malformed links generated by GA
// Can't be a controller because the route parser won't match paths beginning with '?'
import { replaceUrl } from 'libraries/front-end-core/core/history'
import { includes, split } from 'libraries/lodash'

export const GARedirect = queryString => {
  const hasHash = (typeof queryString === 'string') && queryString && includes(queryString, '#/')
  if (hasHash) {
    const [query = '', path = ''] = split(queryString, '#/')
    const redirectTo = query ? path + '?' + query : path
    replaceUrl(redirectTo)
    return true
  }
  return false
}

export function UrlIdpRedirect () {
  return '/gw' + window.location.pathname + window.location.search
}
